module.exports = __webpack_public_path__ + "static/media/rich-comments.31e61c17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot/rich-comments.jpg
// module id = 65
// module chunks = 0